import axios from "axios";
import store from "../store";
import { showToast } from "../store/slices/common";
import {
  deleteSessionData,
  deleteToken,
  getAccessToken,
} from "../utils/auth-token-utils/cookie";

const AxiosInstance = axios;

AxiosInstance.defaults.baseURL = process.env.REACT_APP_BASE_URL;

AxiosInstance.defaults.timeout = 360000;
AxiosInstance.defaults.timeoutErrorMessage = "timeout";

const dispatch = store.dispatch;

const getHeaderObj = (config, accessToken) => {
  if (
    config.url === "/api/admin/login" ||
    config.url === "/auth/signup" ||
    config.url === "/auth/forgot-password"
  ) {
    return {
      "Content-Type": "application/json",
    };
  } else if (
    [
      "/user",
      "/admin/setup-app",
      "/admin/send-push-notification",
      "/api/file/upload",
    ].includes(config.url) &&
    config.method === "post"
  ) {
    return {
      "access-token": `${accessToken}`,
      "Content-Type": "multipart/form-data",
    };
  } else
    return {
      "access-token": `${accessToken}`,
      "Content-Type": "application/json",
    };
};

//  Request interceptor
AxiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = getAccessToken();
    config.headers = getHeaderObj(config, accessToken);
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

//  Response interceptor
AxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },

  (error) => {
    if (error?.response?.data?.message || error?.message) {
      dispatch(
        showToast({
          color: "error",
          msg: error.response?.data?.message?.en || error?.message?.en,
        })
      );
    }
    const accessToken = getAccessToken();

    /**  This block will execute when the token is expired (User logout) */
    if ([401].includes(error?.response?.status) && accessToken) {
      if (!error.request.responseURL?.includes("change-password")) {
        // delete accessToken
        deleteSessionData();
        deleteToken();
        setTimeout(() => {
          window.location.href = "/";
        }, 500);
      }
    }

    return Promise.reject(error);
  }
);

export default AxiosInstance;
